import React from 'react'
import Image from 'next/image'

import { em } from '@/utils'

import { type ICustomImageProps } from './types'

export const CustomImage: React.FC<ICustomImageProps> = ({
  src,
  alt,
  width = 0,
  height = 0,
  style,
  ...rest
}) => {
  return (
    <Image
      {...rest}
      src={src}
      width={width}
      height={height}
      alt={alt ?? ''}
      style={{ width: em(width), height: em(height), ...style }}
    />
  )
}
